import { object, string as yupString } from 'yup'

const MIN_LENGTH = 2
const MAX_LENGTH = 30
const PLEASE_ENTER_FIELD = 'Please enter the required field'

export const contactDetailsSchema = object().shape({
  firstName: yupString()
    .required(PLEASE_ENTER_FIELD)
    .min(MIN_LENGTH, 'Your name must contain at least 2 characters')
    .max(MAX_LENGTH, 'Your name must not exceed 30 characters'),
  lastName: yupString()
    .required(PLEASE_ENTER_FIELD)
    .min(MIN_LENGTH, 'Your last name must contain at least 2 characters')
    .max(MAX_LENGTH, 'Your last name must not exceed 30 characters'),
  email: yupString()
    .required(PLEASE_ENTER_FIELD)
    .email('Invalid email address'),
  phoneNumber: yupString().nullable(),
})
